// frontend/src/components/dashboard/SuggestedCoursesCard.tsx

import { Link } from 'react-router-dom';
import { ArrowRight, Star, BookOpen } from 'lucide-react';
import { Course } from '../../types/courses.types';

interface SuggestedCoursesCardProps {
  courses: Course[];
  age: number | null;
}

const CATEGORY_EMOJI: Record<string, string> = {
  python: '🐍',
  web: '🌐',
  scratch: '🎮',
  ai: '🧠',
  yapay_zeka: '🤖',
  game: '🕹️',
  matematik: '📐',
  fen: '🔬',
  ingilizce: '🇬🇧',
  turkce: '📚',
  veri_analizi: '📊',
};

const CATEGORY_GRADIENT: Record<string, string> = {
  python: 'sg-grad-1',
  web: 'sg-grad-2',
  scratch: 'sg-grad-3',
  ai: 'sg-grad-3',
  yapay_zeka: 'sg-grad-1',
  game: 'sg-grad-3',
  matematik: 'sg-grad-2',
  fen: 'sg-grad-1',
  ingilizce: 'sg-grad-4',
  turkce: 'sg-grad-4',
  veri_analizi: 'sg-grad-2',
};

const DIFFICULTY_LABEL: Record<string, string> = {
  beginner: 'Başlangıç',
  intermediate: 'Orta',
  advanced: 'İleri',
};

function getAgeLabel(age: number | null): string {
  if (!age) return '';
  return `${age} yaş için uygun`;
}

export function SuggestedCoursesCard({ courses, age }: SuggestedCoursesCardProps) {
  if (courses.length === 0) {
    return (
      <div className="nd-suggested-section">
        <div className="nd-suggested-header">
          <h2 className="nd-section-title">
            <span style={{ marginRight: '8px' }}>💡</span>
            Sana Önerilen Dersler
          </h2>
          {age && <span className="nd-age-badge">👶 {getAgeLabel(age)}</span>}
        </div>
        <div className="nd-empty">
          <p>Henüz önerilebilecek ders bulunamadı.</p>
          <Link to="/courses" className="nd-link-btn">Tüm Derslere Bak →</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="nd-suggested-section">
      <div className="nd-suggested-header">
        <div className="nd-suggested-header-left">
          <h2 className="nd-section-title">
            <span style={{ marginRight: '8px' }}>💡</span>
            Sana Önerilen Dersler
          </h2>
          {age && <span className="nd-age-badge">🎯 {getAgeLabel(age)}</span>}
        </div>
        <Link to="/courses" className="nd-see-all">
          Tümünü Gör <ArrowRight size={15} />
        </Link>
      </div>
      <div className="nd-suggested-grid">
        {courses.map((course) => {
          const emoji = CATEGORY_EMOJI[course.category] ?? '📘';
          const grad = CATEGORY_GRADIENT[course.category] ?? 'sg-grad-1';
          const diff = DIFFICULTY_LABEL[course.difficulty] ?? course.difficulty;
          // Sahte ama tutarlı rating (course id hash'inden)
          const fakeRating = (4.6 + (course.id.charCodeAt(0) % 4) * 0.1).toFixed(1);

          return (
            <Link to={`/courses/${course.id}`} key={course.id} className="nd-suggested-card">
              <div className={`nd-suggested-emoji-wrap ${grad}`}>
                <span className="nd-suggested-emoji">{emoji}</span>
              </div>
              <div className="nd-suggested-info">
                <h3 className="nd-suggested-name">{course.title}</h3>
                <div className="nd-suggested-meta">
                  <span className="nd-suggested-lessons">
                    <BookOpen size={12} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
                    {course.lessonCount ?? '10'} Ders
                  </span>
                  <span className="nd-suggested-level">{diff}</span>
                </div>
                <div className="nd-suggested-rating">
                  <Star size={12} fill="#F59E0B" color="#F59E0B" />
                  <span>{fakeRating}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

